<template>
	<div>
		<v-snackbar v-model="savedNotif" top>
			Position Template Saved
			<v-btn color="pink" flat @click="savedNotif = false">
				Close
			</v-btn>
		</v-snackbar>

		<v-form>
			<v-container grid-list-xl fluid>
				<v-layout row wrap>
					<v-flex lg5>
						<v-card class="mb-4">
							<v-toolbar flat dense cad>
								<v-toolbar-title class="subheading">Position Detail</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>

							<v-divider></v-divider>

							<v-card-text>
								<v-text-field 
								v-model="form.title" 
								:error-messages="titleErrors" 
								label="Position Title" 
								required></v-text-field>

								<v-select
									v-model="form.department"
									:items="departmentsOrdered"
									:error-messages="departmentErrors"
									item-text="name"
									return-object
									label="Department"
									required
								></v-select>


								<v-textarea v-model="form.description" 
								:error-messages="descriptionErrors" 
								required box label="Position Purpose"></v-textarea>
							</v-card-text>
						</v-card>
					</v-flex>

					<v-flex lg7 xs12>
						<v-tabs v-model="active_tab" left fixed-tabs show-arrows color="info" dark slider-color="white">
							<v-tab>
								KPI's
							</v-tab>
							<v-tab class="noPrint">
								Key Duties
							</v-tab>
							<v-tab class="noPrint">
								Person Specification
							</v-tab>

							<v-tab-item>
								<v-card class="mb-4" flat>
									<v-divider></v-divider>

									<v-card-text>
										<kpi-helper />

										<employee-position-item-list 
											item-header-text="KPI" 
											:position-items="kpis" 
											enableReorder
											@onSortOrderUpdated="onSortOrderUpdated"
											@onEditPositionItem="onEditPositionItem" 
											@onDeletePositionItem="onDeletePositionItem"> 
										</employee-position-item-list>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn flat @click="onAddPositionItem(1)"><v-icon left>add</v-icon>Add</v-btn>
									</v-card-actions>
								</v-card>
							</v-tab-item>

							<v-tab-item>
								<v-card class="mb-4" flat>
									<v-divider></v-divider>

									<v-card-text>
										<key-duty-helper />

										<employee-position-item-list 
										item-header-text="Key Duty" 
										:position-items="keyDuties" 
										enableReorder
										@onSortOrderUpdated="onSortOrderUpdated"
										@onEditPositionItem="onEditPositionItem" 
										@onDeletePositionItem="onDeletePositionItem"> 
										</employee-position-item-list>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn flat @click="onAddPositionItem(2)"><v-icon left>add</v-icon>Add</v-btn>
									</v-card-actions>
								</v-card>
							</v-tab-item>
							<v-tab-item>
								<v-card class="mb-4" flat>
									<v-divider></v-divider>

									<v-card-text>
										<person-specification-helper />

										<employee-position-item-list
											:show-category-column="false"
											item-header-text="Specification"
											:position-items="personSpecification"
											enableReorder
											@onSortOrderUpdated="onSortOrderUpdated"
											@onEditPositionItem="onEditPositionItem"
											@onDeletePositionItem="onDeletePositionItem"
										>
										</employee-position-item-list>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn flat @click="onAddPositionItem(5)"><v-icon left>add</v-icon>Add</v-btn>
									</v-card-actions>
								</v-card>
							</v-tab-item>
						</v-tabs>

						<add-position-item-multi v-if="addPositionItemDialog" :performance-review="false" :type="positionItemDialogType" @save="savePositionItemAddMulti" @closeEditor="closePositionItemEditor"> </add-position-item-multi>

						<employee-position-item-editor
							v-if="positionItemDialog"
							:position-item="editedPositionItem"
							:performance-review="false"
							:type="positionItemDialogType"
							:hide-category="positionItemDialogType == 5 ? true : false"
							@save="savePositionItem"
							@closeEditor="closePositionItemEditor"
						>
						</employee-position-item-editor>
					</v-flex>
				</v-layout>
			</v-container>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<span class="last-saved-date ml-1 mr-2" v-if="autoSave && lastSavedDate">(Last saved <AppDate :date="lastSavedDate" format="hh:mm a" prepend-tooltip="Last saved" show-date />)</span>			
				<v-switch v-model="autoSave" label="Auto Save Changes" class="mr-2" style="flex:none;"></v-switch>
				
				<footer-back-btn @click="cancel" />

				<v-btn class="action-btn" :disabled="isSaving" :loading="isSaving" @click="save(false)">Save Template
					<span slot="loader">Saving...</span>
				</v-btn>
			</v-footer>
		</v-form>

<v-dialog v-if="duplicateDialog" v-model="duplicateDialog" persistent max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">Create a Duplicate</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<v-text-field v-model="duplicateForm.title" 
						:error-messages="duplicateFormTitleErrors" 
						label="Position Title" 
						required 
						@input="$v.duplicateForm.title.$touch()" 
						@blur="$v.duplicateForm.title.$touch()">
					</v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="duplicateDialog = false">Cancel</v-btn>
					<v-btn color="primary" flat :disabled="isDuplicating" :loading="isDuplicating" @click="duplicatePositionDescription">Duplicate <span slot="loader">Saving...</span></v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>

	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { validationMixin } from 'vuelidate';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import { required } from 'vuelidate/lib/validators';
	import EmployeePositionItemList from '@/components/employee/EmployeePositionItemList';
	import EmployeePositionItemEditor from '@/components/employee/EmployeePositionItemEditor';
	import AddPositionItemMulti from '@/components/AddPositionItemMulti';
	import KpiHelper from '@/components/helpers/KpiHelper';
	import PersonSpecificationHelper from '@/components/helpers/PersonSpecificationHelper';
	import KeyDutyHelper from '@/components/helpers/KeyDutyHelper';

	let autoSaveTimeoutId;

	export default {
		components: {
			EmployeePositionItemEditor,
			EmployeePositionItemList,
			AddPositionItemMulti,
			KpiHelper,
			PersonSpecificationHelper,
			KeyDutyHelper
		},
		props: {
			positionTemplate: {
				type: Object,
				default: () => ({
					id: null,
					title: '',
					description: '',
					department: null,
					positionItems: []
				})
			}
		},
		data() {
			return {
				active_tab: 0,
				form: null,
				positionItemDialog: false,
				positionItemDialogType: null,
				editedPositionItemId: null,
				editedPositionItem: undefined,
				addPositionItemDialog: false,
				autoSave: true,
				originalSerialised: null,
				savedNotif: false,
				isSaving: false,
				lastSavedDate: null,
				duplicateDialog: false,
				duplicateForm: {
					title: ''
				},
				isDuplicating: false
			};
		},
		created() {
			this.form = JSON.parse(JSON.stringify(this.positionTemplate));
			this.autoSave = this.isEdit;
		},
		watch: {
			formSerialised(newVal, oldVal) {	
				if(this.autoSave && oldVal != "null") {
					// If a timer was already started, clear it.
					if (autoSaveTimeoutId) 
						clearTimeout(autoSaveTimeoutId);

					autoSaveTimeoutId = setTimeout(() => {
						this.save(true);
					}, 2000);
				}
			}
		},
		mixins: [validationMixin, typeFriendlyMixin],
		validations: {
			form: {
				title: { required },
				description: { required },
				department: { required }
			}, 
			duplicateForm: {
				title: { required }
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				departments: 'departments/departments'
			}),
			isEdit() {
				return this.form.id != null;
			},
			formSerialised() {
				return JSON.stringify(this.form);
			},
			departmentErrors() {
				const errors = [];
				if (!this.$v.form.department.$dirty) return errors;
				!this.$v.form.department.required && errors.push('Department is required.');
				return errors;
			},
			titleErrors() {
				const errors = [];
				if (!this.$v.form.title.$dirty) return errors;
				!this.$v.form.title.required && errors.push('Position Title is required.');
				return errors;
			},
			descriptionErrors() {
				const errors = [];
				if (!this.$v.form.description.$dirty) return errors;
				!this.$v.form.description.required && errors.push('Description is required.');
				return errors;
			},
			departmentsOrdered() {
				var departments = this.departments.slice(0);
				var sorted = departments.sort();
				sorted.unshift({ id: null, name: 'N/A' });
				return sorted;
			},
			duplicateFormTitleErrors() {
				const errors = [];
				if (!this.$v.duplicateForm.title.$dirty) return errors;
				!this.$v.duplicateForm.title.required && errors.push('Position Title is required.');
				return errors;
			},
			kpis() {
				return this.form.positionItems !== null ? this.form.positionItems.filter(x => x.type == 1) : [];
			},
			keyDuties() {
				return this.form.positionItems !== null ? this.form.positionItems.filter(x => x.type == 2) : [];
			},
			personSpecification() {
				return this.form.positionItems !== null ? this.form.positionItems.filter(x => x.type == 5) : [];
			}
		},

		methods: {
			save(viaAutoSave) {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {

					if(viaAutoSave) {
						console.log('Autosaving...');
					}		
					else {
						this.isSaving = true;
					}
						
					let postObj = {
						id: this.form.id != undefined ? this.form.id : null,
						title: this.form.title,
						description: this.form.description,
						department: this.form.department,
						positionItems: this.form.positionItems
					}

					if(this.isEdit) {
						this.$store.dispatch('positionTemplates/edit', postObj).then(
							data => {
								if (!viaAutoSave) {
									this.$router.push({ name: 'positionTemplate', params: { id: data.id }});
								} else {
									this.lastSavedDate = new Date();
									this.isSaving = false;
								}
							},
							error => {
								console.error('Error saving position template');
								this.isSaving = false;
							}
						);
					} else {
						this.$store.dispatch('positionTemplates/add', postObj).then(
							data => {
								if (!viaAutoSave) {
									this.$router.push({ name: 'positionTemplate', params: { id: data.id }});
								} else {
									this.form.id = data.id;
									this.lastSavedDate = new Date();
									this.isSaving = false;
								}
								
							},
							error => {
								console.error('Error saving position template');
								this.isSaving = false;
							}
						);
					}				
				}
			},
			clear() {
				this.$v.form.$reset();
				this.form.title = '';
				this.form.description = '';
				this.form.positionItems = [];
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			closePositionItemEditor() {
				this.positionItemDialog = false;
				this.addPositionItemDialog = false;
			},
			onEditPositionItem(item) {
				this.editedPositionItemId = item.id;
				this.editedPositionItem = Object.assign({}, item);
				this.positionItemDialogType = this.editedPositionItem.type;
				this.positionItemDialog = true;
			},
			onAddPositionItem(type) {
				this.positionItemDialogType = type;
				this.editedPositionItemId = null;
				this.editedPositionItem = undefined;
				this.positionItemDialog = true;
			},
			onDeletePositionItem(item) {
				const index = this.form.positionItems.findIndex(x => x.id === item.id);
				confirm('Are you sure you want to delete this duty?') && this.form.positionItems.splice(index, 1);
			},
			onSortOrderUpdated(items) {
				// Creates a new array. Removes sorted chunk and adds them to the end. Probably 50 better ways of doing this.
				const updatedIds = items.map(x => x.id);

				let newArr = this.form.positionItems.filter(x => !updatedIds.includes(x.id));

				this.form.positionItems = [...newArr, ...items];
			},
			onDuplicateClick() {
				this.$v.duplicateForm.$reset();
				this.duplicateDialog = true;
			},
			duplicatePositionDescription() {
				this.$v.duplicateForm.$touch();

				if (this.$v.duplicateForm.$invalid) {
					console.log('invalid form');
				} else {
					this.isDuplicating = true;

					let positionTemplate = {
						id: this.newGuid(),
						title: this.duplicateForm.title,
						description: this.form.description,
						department: this.form.department,
						positionItems: this.form.positionItems
					};

					this.$store.dispatch('positionTemplates/add', positionTemplate).then(
							data => {										
								this.isDuplicating = false;
								this.$router.push(`/positionTemplate/${data.id}/edit`);
							},
							error => {
								console.error('Error duplicating position template');
								this.isDuplicating = false;
							}
						);
				}
			},
			savePositionItem(positionItem) {
				if (this.editedPositionItemId) {
					const index = this.form.positionItems.findIndex(x => x.id === this.editedPositionItemId)
					if (index > -1) {
						this.form.positionItems.splice(index, 1, positionItem);
					}
				} else {
					this.form.positionItems.push(positionItem);
				}
			},
			savePositionItemAddMulti(data) {
				for (let i = 0; i < data.items.length; i++) {
					this.form.positionItems.push({
						id: null,
						category: data.category,
						item: data.items[i].item,
						outcomes: data.items[i].outcomes,
						type: data.type
					});
				}
			},
			cancel() {
				window.history.back();
			}
		}
	};
</script>
<style scoped> 
	
</style>